var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGalleryImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gallery_image",
    "data-name": "gallery image",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "themeSVGStroke themeSVGStrokeHover",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "art"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "themeable",
    id: "Rectangle_1763",
    "data-name": "Rectangle 1763",
    x: 3,
    y: 3,
    width: 22,
    height: 22,
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    className: "themeable",
    id: "Path_10623",
    "data-name": "Path 10623",
    d: "M9,29H29V9",
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "themeable",
    id: "Rectangle_1764",
    "data-name": "Rectangle 1764",
    x: 13,
    y: 11,
    width: 8,
    height: 14,
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "themeable",
    id: "Rectangle_1765",
    "data-name": "Rectangle 1765",
    x: 7,
    y: 17,
    width: 6,
    height: 8,
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    className: "themeable",
    id: "Line_14476",
    "data-name": "Line 14476",
    x1: 17,
    y1: 11,
    x2: 17,
    y2: 7,
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "square"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1766",
    "data-name": "Rectangle 1766",
    width: 32,
    height: 32,
    style: {
      fill: "none"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryImage);
export default __webpack_public_path__ + "static/media/gallery_image.ad61ccb4ce17aba56cda332ada9e780d.svg";
export { ForwardRef as ReactComponent };